var exports = {
  "Ef": "UserAreaPopout.module__customStatusRow___dmtVV2",
  "fF": "UserAreaPopout.module__customStatusPlaceholder___dmtVV2",
  "yB": "UserAreaPopout.module__customStatusPlaceholderText___dmtVV2",
  "mo": "UserAreaPopout.module__customStatusPlaceholderIcon___dmtVV2",
  "Ar": "UserAreaPopout.module__copyUsernameButton___dmtVV2",
  "kL": "UserAreaPopout.module__container___dmtVV2",
  "qr": "UserAreaPopout.module__footer___dmtVV2",
  "mH": "UserAreaPopout.module__actionGroup___dmtVV2",
  "Gv": "UserAreaPopout.module__editProfileButton___dmtVV2",
  "hP": "UserAreaPopout.module__actionButton___dmtVV2",
  "k3": "UserAreaPopout.module__actionDivider___dmtVV2",
  "d3": "UserAreaPopout.module__actionButtonDisabled___dmtVV2",
  "gE": "UserAreaPopout.module__actionIcon___dmtVV2",
  "Iz": "UserAreaPopout.module__actionContent___dmtVV2",
  "ZJ": "UserAreaPopout.module__actionLabel___dmtVV2",
  "aN": "UserAreaPopout.module__actionHint___dmtVV2",
  "oS": "UserAreaPopout.module__actionChevron___dmtVV2",
  "qW": "UserAreaPopout.module__statusMenu___dmtVV2" + " " + __webpack_require__(3243)["HG"],
  "C6": "UserAreaPopout.module__expiryPopup___dmtVV2" + " " + __webpack_require__(3243)["HG"],
  "MH": "UserAreaPopout.module__statusMenuRow___dmtVV2",
  "v0": "UserAreaPopout.module__statusMenuItem___dmtVV2" + " " + __webpack_require__(3243)["AS"],
  "Tb": "UserAreaPopout.module__statusMenuIcon___dmtVV2",
  "Te": "UserAreaPopout.module__statusMenuText___dmtVV2",
  "Ye": "UserAreaPopout.module__statusMenuLabel___dmtVV2",
  "wK": "UserAreaPopout.module__statusMenuDescription___dmtVV2" + " " + __webpack_require__(3243)["Lo"],
  "Tc": "UserAreaPopout.module__statusMenuChevron___dmtVV2",
  "L7": "UserAreaPopout.module__expiryItem___dmtVV2" + " " + __webpack_require__(3243)["AS"],
  "ue": "UserAreaPopout.module__expiryLabel___dmtVV2",
};

module.exports = exports;
